var image_viewer_rtlignore_default = {
  "fontElementMap": "ofQfA",
  "imageContainer": "e3LjG",
  "expandButton": "Yqv-q",
  "expandIcon": "n4Kdj",
  "pointer": "-oLcC",
  "imageWrapper": "SDH1R",
  "imageRatio": "KlHWe",
  "image": "QwdtT",
  "imageOverlay": "yd0Vx",
  "imagePreload": "_10cxF",
  "imageHighres": "kxOOS",
  "onlyHighRes": "FvY5R",
  "image_loading": "rNVME"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
